import { Button, KIND, SIZE } from 'baseui/button'
import { ChevronLeft, ChevronRight } from 'baseui/icon'
import { useStyletron } from 'baseui'

const PaginationControls = ({ 
  currentPage, 
  totalPages, 
  onPageChange, 
  t,
  translationPrefix = 'subscriptionTools:pce_search' 
}) => {
  const [css] = useStyletron()

  if (totalPages <= 1) return null

  return (
    <div
      className={css({
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '0.5rem',
        marginTop: '1rem',
      })}
    >
      <Button
        size={SIZE.mini}
        kind={KIND.secondary}
        disabled={currentPage === 1}
        onClick={() => onPageChange(currentPage - 1)}
        startEnhancer={() => <ChevronLeft size={16} />}
      >
        {t(`${translationPrefix}.pagination.previous`)}
      </Button>

      <span className={css({ padding: '0 16px' })}>
        {currentPage} {t(`${translationPrefix}.pagination.preposition`)} {totalPages}
      </span>

      <Button
        size={SIZE.mini}
        kind={KIND.secondary}
        disabled={currentPage === totalPages}
        onClick={() => onPageChange(currentPage + 1)}
        endEnhancer={() => <ChevronRight size={16} />}
      >
        {t(`${translationPrefix}.pagination.next`)}
      </Button>
    </div>
  )
}

export default PaginationControls
